import dayjs from 'dayjs';
import { ContentType } from 'recharts/types/component/Tooltip';

const TooltipContent: ContentType<number, string> = ({
  active,
  payload,
  label,
}) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white border border-gray-100 px-4 py-2 focus:outline-none">
        <div className="text-sm">
          {dayjs.unix(label).format('MMMM D YYYY, h:mm:ss a')}
        </div>
        {payload
          .filter((p) => !p.name.startsWith('Threshold'))
          .map((p, i) => (
            <div className="text-sm" key={i} style={{ color: p.color }}>
              {`${p.name} : ${p.value} `}
            </div>
          ))}
      </div>
    );
  }

  return null;
};

export default TooltipContent;
